/**
 * src/api/metrics.js
 *
 * API calls backed by gaussiq-intelligence's /api/metrics/* routes.
 */

import { authedJson } from './http'

const apiGet = path => authedJson('GET', path)

/**
 * Fetch the outcome-metric cards for the Home tab's Customer Outcome
 * Performance panel (Gross MTTR, Net MTTR, Eng Assist, ...).
 * GET /metrics/outcome (proxied under the shared /api prefix — see BASE_URL in src/api/http.js)
 *
 * The backend stores each metric's value as a JSON-encoded string in a
 * `text` column (see gaussiq-intelligence's core/metrics/generate.py), so
 * each row's `metric_value` needs parsing here. That inner blob is an
 * opaque pre-shaped UI payload (MTD/3MONTH/BASELINETODATE/BASELINE + per-
 * period `*_change`/`*_RANGE` strings) which — like `hero`/`meta` blobs
 * elsewhere in this app (see src/api/control.js) — is passed through
 * untranslated rather than remapped key-by-key.
 *
 * @returns {Promise<Array<{name: string, tag: string, metric: object}>>}
 */
export async function fetchOutcomeMetrics() {
  const rows = await apiGet('/metrics/outcome')
  if (!Array.isArray(rows)) return []
  return rows
    .map(row => {
      let metric
      try { metric = JSON.parse(row.metric_value) } catch { return null }
      return { name: row.metric_name, tag: row.metric_tag, metric }
    })
    .filter(Boolean)
}
